module.exports = __webpack_public_path__ + "static/automating-inequality-2dc42624b48534917c454d9c2aa8d479.jpg";